/**
 * Categoria do tutorial.
 * Valores são persistidos no Firestore (collection tutoriais).
 */
export enum TutorialCategory {
  PARCEIRO = "parceiro",
  FRANQUIA = "franquia",
  CONSUMIDOR = "consumidor",
}

export const TutorialCategoryLabel: Record<TutorialCategory, string> = {
  [TutorialCategory.PARCEIRO]: "Parceiros",
  [TutorialCategory.FRANQUIA]: "Franqueados",
  [TutorialCategory.CONSUMIDOR]: "Consumidor",
};

export const TUTORIAL_CATEGORY_OPTIONS = Object.values(TutorialCategory).map((value) => ({
  value,
  text: TutorialCategoryLabel[value],
}));
